<template>
  <div class="flex-row-start-center gap-3 history-filter">
    <div class="text-body-2 text--text">{{ $t("filter") }}:</div>
    <div class="text-body-2 secondaryText--text">{{ $t("fromDate") }}</div>
    <v-text-field
      :value="from"
      :disabled="loading"
      :loading="loading"
      dense
      solo
      flat
      readonly
      clearable
      id="filter-from"
      style="max-width: 150px"
      @click="fromDatePicker = true"
      @input="onDateChange($event, 'created_at_from')"
    />
    <aironpax-date-picker
      custom-input="#filter-from"
      :value="from"
      :show="fromDatePicker"
      @close="fromDatePicker = false"
      @change="onDateChange($event, 'created_at_from')"
    />
    <div class="text-body-2 secondaryText--text">{{ $t("toDate") }}</div>
    <v-text-field
      :value="to"
      :disabled="loading"
      :loading="loading"
      dense
      solo
      flat
      readonly
      id="filter-to"
      style="max-width: 150px"
      @click="toDatePicker = true"
      @input="onDateChange($event, 'created_at_to')"
    />
    <aironpax-date-picker
      custom-input="#filter-to"
      :value="to"
      :show="toDatePicker"
      @close="toDatePicker = false"
      @change="onDateChange($event, 'created_at_to')"
    />
    <div class="text-body-2 secondaryText--text">{{ $t("limit") }}</div>
    <v-text-field
      :value="limit"
      :disabled="loading"
      :loading="loading"
      dense
      solo
      flat
      clearable
      type="number"
      style="max-width: 100px"
      @input="onLimitChange"
    />
  </div>
</template>

<script>
import moment from "jalali-moment";

export default {
  name: "HistoryFilter",

  props: {
    loading: { type: Boolean, default: false },
    filterData: { type: Object, required: true },
  },

  data() {
    return {
      fromDatePicker: false,
      toDatePicker: false,
      timeout: null,
    };
  },

  computed: {
    from() {
      if (!this.filterData.created_at_from) return undefined;
      return moment(this.filterData.created_at_from).format("jYYYY/jMM/jDD");
    },
    to() {
      if (!this.filterData.created_at_to) return undefined;
      return moment(this.filterData.created_at_to).format("jYYYY/jMM/jDD");
    },
    limit() {
      return this.filterData.limit;
    },
  },

  methods: {
    onDateChange(date, key) {
      const value = date
        ? moment(new Date(date)).format("YYYY-MM-DD")
        : undefined;
      this.$emit("filter", { key, value });
    },
    onLimitChange(value) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => {
        this.$emit("filter", { key: "limit", value });
      }, 800);
    },
  },
};
</script>

<style lang="scss">
.history-filter {
  & .v-text-field__details {
    display: none;
  }
}
</style>
